define('views/modules/questionnaire/responses/stats/questionnaire-stats',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // collections
    'collections/questionnaire/responses',
    'collections/questionnaire/questions',
    // views
    'views/parts/chart/bar-chart',
    'views/parts/chart/pie-chart',
    // templates
    'text!templates/modules/questionnaire/responses/stats/questionnaire-stats.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // collections
    CResponses,
    CQuestions,
    // views
    VBarChart,
    VPieChart,
    // templates
    TQuestionnaireStats
) {

    var VQuestionnaireStats = Backbone.View.extend({

        template: TQuestionnaireStats,

        regions: {
            list: ".questions-list",
            chart: ".chart"
        },

        initialize: function(opt) {
            opt = opt || {};

            var model = new Backbone.Model({
                answers: [
                    { text: "Oui", count: 10 },
                    { text: "Non", count: 2 }
                ]
            });

            this.questions = new CQuestions();
            var chartDatas = this.setGraphDatas(model.get('answers'));

            this.collection = new CResponses(null, {
                questionnaire: this.model
            });

            this.view = {
                chart: new VBarChart({
                    labels: chartDatas.labels,
                    data: chartDatas.data,
                })
            };

        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.chart, zone.$chart);

            this.collection.getFirstPage();
            // this.renderStats();

        },

        renderStats: function() {
            var questions = this.questions.reset(this.model.getQuestions());

            _.each(questions, function(model) {
                this.renderOneStat(model);
            }, this);
        },

        renderOneStat: function(model) {
            model.set('answers', [
                { text: "Oui", count: 2 },
                { text: "Non", count: 1 }
            ]);
            var view,
                type = model.get('type'),
                answers = model.get('answers'),
                chartDatas = this.setGraphDatas(answers);

            if (type === 'text' || type === 'textarea') { // simply display all the answer in a list (table with one td)

            } else if (answers.length > 2) {
                // view = new VPieChart({
                //     labels: this.chartLabels,
                //     data: this.chartData,
                // });

            } else {
                view = new VBarChart({
                    labels: chartDatas.labels,
                    data: chartDatas.data,
                });
            }

            view.render();
            this.zone.$list.append(view.el);
        },

        setGraphDatas: function(answers) {
            var labels = [];
            var data = [];

            _.each(answers, function(value) {
                data.push(value.count);
                labels.push(value.text);
            }, this);

            return { data: data, labels: labels };
        },

    });

    return VQuestionnaireStats;

});

